// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sx","title":"sy","year":"sz","genres":"sA","buttonWrapper":"sB","button":"sC u2"};